"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils_common_get_cookie_1 = __importDefault(require("@gcloud-npm/utils.common.get-cookie"));
const utils_common_is_webview_1 = __importDefault(require("@gcloud-npm/utils.common.is-webview"));
const shouldLoadOneTrust = (setCookieVisibility) => __awaiter(void 0, void 0, void 0, function* () {
    const forceShowCookies = window.location.href.indexOf("showCookies") > -1;
    const cookiesAcepted = (0, utils_common_get_cookie_1.default)("OptanonAlertBoxClosed");
    const isProperEnvironment = `${process.env.NEXT_PUBLIC_ENV_NAME}` === "prod";
    let cookiesCdn = (isProperEnvironment && !cookiesAcepted) || forceShowCookies;
    if ((0, utils_common_is_webview_1.default)()) {
        // analizamos el status
        let retries = 10;
        let waitWB = setInterval(() => __awaiter(void 0, void 0, void 0, function* () {
            retries--;
            if (window.webviewBridge) {
                retries = -1;
                const status = yield window.webviewBridge.getAttStatus();
                const nullCookieValue = status === null;
                if (nullCookieValue && cookiesCdn) {
                    setCookieVisibility(cookiesCdn);
                }
            }
            if (retries < 0) {
                clearInterval(waitWB);
            }
        }), 100);
    }
    if (cookiesCdn) {
        setCookieVisibility(true);
    }
});
exports.default = shouldLoadOneTrust;
//# sourceMappingURL=index.js.map